import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './PolicyPages.css';
import { Link } from 'react-router-dom';

const PrivacyPolicy = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="policy-container" data-aos="fade-up">
      <header className="policy-header" data-aos="fade-down">
        <h1>Privacy Policy</h1>
        <p>Last updated: November 27, 2025</p>
      </header>

      <section className="policy-section" data-aos="fade-right">
        <h2>1. Information We Collect</h2>
        <p>We collect information to provide and improve our services. The types of information we collect include:</p>
        <ul>
          <li><strong>Personal Information:</strong> Name, email address, shipping address, phone number, and payment information when you create an account or place an order.</li>
          <li><strong>Usage Data:</strong> Information on how you access and use the Service, such as your IP address, browser type, and pages visited.</li>
          <li><strong>Cookies:</strong> We use cookies to track activity on our Service and hold certain information.</li>
        </ul>
      </section>

      <section className="policy-section" data-aos="fade-left">
        <h2>2. How We Use Your Information</h2>
        <p>Lable Aadvi uses the collected data for various purposes:</p>
        <ul>
          <li>To provide and maintain our Service</li>
          <li>To notify you about changes to our Service</li>
          <li>To allow you to participate in interactive features of our Service when you choose to do so</li>
          <li>To provide customer support</li>
          <li>To gather analysis or valuable information so that we can improve our Service</li>
          <li>To monitor the usage of our Service</li>
          <li>To detect, prevent and address technical issues</li>
          <li>To process your orders and manage your account</li>
        </ul>
      </section>

      <section className="policy-section" data-aos="fade-left">
        <h2>3. Payment Processing</h2>
        <p>We use a third-party payment processor, <strong>Razorpay</strong>, to handle all payment transactions. When you make a purchase, your payment information is provided directly to Razorpay. We do not store your full credit card or debit card information on our servers.</p>
        <p>Your payment data is subject to Razorpay's privacy policy, which we encourage you to review. We only receive information from Razorpay necessary to confirm your payment and process your order, such as a transaction ID and confirmation of payment status.</p>
      </section>

      <section className="policy-section" data-aos="fade-right">
        <h2>4. Sharing Your Information</h2>
        <p>We do not sell, trade, or otherwise transfer to outside parties your Personally Identifiable Information unless we provide users with advance notice. This does not include website hosting partners and other parties who assist us in operating our website, conducting our business, or serving our users (such as our payment processor, Razorpay), so long as those parties agree to keep this information confidential.</p>
      </section>

      <section className="policy-section" data-aos="fade-left">
        <h2>5. Data Security</h2>
        <p>The security of your data is important to us, but remember that no method of transmission over the Internet or method of electronic storage is 100% secure. While we strive to use commercially acceptable means to protect your Personal Data, we cannot guarantee its absolute security.</p>
      </section>

      <section className="policy-section" data-aos="fade-right">
        <h2>6. Your Data Protection Rights</h2>
        <p>You have certain data protection rights. Label Aadvi aims to take reasonable steps to allow you to correct, amend, delete, or limit the use of your Personal Data. If you wish to be informed what Personal Data we hold about you and if you want it to be removed from our systems, please contact us.</p>
      </section>

      <section className="policy-section" data-aos="fade-left">
        <h2>7. Changes to This Privacy Policy</h2>
        <p>We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page. You are advised to review this Privacy Policy periodically for any changes.</p>
      </section>

      <section className="policy-section" data-aos="fade-up">
        <h2>8. Contact Us</h2>
        <p>If you have any questions about this Privacy Policy, please <Link to="/contact">contact us</Link>.</p>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
